<div class="row">
  <div
    *ngFor="let prop of formattedFormFields.form_fields"
    class="{{ calculateColumnWidth(prop) }}"
  >
    <div [ngSwitch]="prop.field_component">
      <check-box
        *ngSwitchCase="'check'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></check-box>
      <radio-button
        *ngSwitchCase="'radio'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></radio-button>
      <select-box
        *ngSwitchCase="'select'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></select-box>
      <date-picker
        *ngSwitchCase="'date'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></date-picker>
      <empty-box
        *ngSwitchCase="'empty_box'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
      ></empty-box>
      <field-divider
        *ngSwitchCase="'field_divider'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
      ></field-divider>
      <full-divider
        *ngSwitchCase="'full_divider'"
        [prop]="prop"
        [viewExpanded]="viewExpanded"
      ></full-divider>
      <text-box
        *ngSwitchDefault
        [prop]="prop"
        [viewExpanded]="viewExpanded"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></text-box>
      <group-fields *ngSwitchCase="'groupfields'" [prop]="prop" [graphicFormGroup]="graphicFormGroup"
                    [detailFormDataModel]="detailFormDataModel"></group-fields>
      <dms-image *ngSwitchCase="'dmsimage'" [prop]="prop" [graphicFormGroup]="graphicFormGroup"
                 [detailFormDataModel]="detailFormDataModel"></dms-image>
    </div>
  </div>
</div>
